<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadGroups(1, null, true)">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('group_name')" v-model="groupFormData.name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationGroupButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addGroup">{{ $t('add_group') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('group_name')" v-model="groupSearchParams.group" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="groupSearchParams.isActive" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadGroups(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="groupDataContainer" :title="$t('groups')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-member-group-list
        :groups="groups"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-member-group-list>

      <template slot="footer">
        <paginate
          :total="groupPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadGroups"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import Group from '@/models/Group'
import SharedUserConfigurationMemberGroupList from '@/views/Shared/Configuration/Member/Groups/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Member.Groups',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationMemberGroupList
  },
  data () {
    return {
      groupsEdit: {},
      groups: {},
      groupPages: 1,
      groupFormData: {
        name: '',
        is_active: '',
        id: ''
      },
      groupFormErrors: {},
      itemPerPage: null,
      groupSearchParams: {
        group: typeof this.$route.query.group !== 'undefined' ? this.$route.query.group : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadGroups(this.initialPage, null, false, true)
  },
  methods: {
    async loadGroups (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#groupDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: {...this.groupSearchParams, page, itemPerPage}})
      }
      const response = await Group.all({ ...this.groupSearchParams, page, itemPerPage })
      this.groups = response.data.data.groups
      this.groupPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#groupDataContainer > .con-vs-loading')
    },
    async addGroup (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationGroupButton', scale: 0.45})
      if (this.groupFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_group_error_message'),
          confirmButton: this.$t('confirm')
        })

        this.$store.dispatch('setIsFormInProgress', false)

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await Group.save(this.groupFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadGroups(1, this.itemPerPage)
        this.groupFormData = {
          name: '',
          is_active: '',
          id: ''
        }
        this.groupFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationGroupButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.groups[key].is_active === 1) {
          this.groups[key].is_active = 0
        } else {
          this.groups[key].is_active = 1
        }
        await Group.update(this.groups[key])
        this.groups[key].groupFormErrors = {}
      } catch (e) {
        this.groups[key].groupFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.groups[key].edit = true
      const editElem = this.groups[key]
      const editObj = {
        name: editElem.name
      }
      this.groupsEdit[key] = editObj
    },
    async cancel (key) {
      this.groups[key].name = this.groupsEdit[key].name
      this.groups[key].edit = false
      this.groups[key].groupFormErrors = {}
      delete this.groupsEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('group_update_confirmation_title'),
          text: this.$t('group_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationGroupButton${ id }`, scale: 0.45})
          await Group.update(this.groups[key])
          this.groups[key].edit = false
          this.groups[key].groupFormErrors = {}
          this.$vs.loading.close(`#updateConfigurationGroupButton${ id } > .con-vs-loading`)
        }
      } catch (e) {
        this.groups[key].groupFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateConfigurationGroupButton${ id } > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Group.destroy(id)
        this.loadGroups(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationGroupButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
